import React, { useRef } from 'react'
import Layout from '../layouts'
import SEO from '../components/seo'
import Image from '../components/image'
import Intro from '../components/intro'
import Content from '../components/content'
import Info from '../components/info'
import Block from '../components/block'
import { animated } from 'react-spring'
import useIsInViewport from 'use-is-in-viewport'
import useAnimate from '../hooks/useAnimate'
import P from '../components/paragraph'

const AnimatedImage = animated(Image)
const AnimatedBlock = animated(Block)

const Venue = () => {
  const fadeIn = useAnimate()
  const travelRef = useRef(null)
  const [isInViewport, wrappedRef] = useIsInViewport({
    target: travelRef,
    modBottom: '-10%'
  })
  const fadeInTrigger = useAnimate({ trigger: isInViewport })

  return (
    <Layout>
      <SEO title="Venue &amp; Travel" />
      <Intro>
        <h1>Venue &amp; Travel</h1>
        <P narrow>
          Our venue is located at Domaine de Grammont, avenue Albert Einstein, 34000 MONTPELLIER. 
          Please find a map and directions below. You can also use the Moovit app to get there.
        </P>
      </Intro>
      <AnimatedImage style={fadeIn(250)} height={350} file="dorsetHouse" />
      <Content css="margin-top: 2em;" columns>
        <AnimatedBlock style={fadeIn(500)}>
          <h3>Directions</h3>
          <p>
          Located in the east of Montpellier, le Domaine de Grammont is a quiet place, surrounded by vineyards. 
          </p>
          <Info>
            <strong>Domaine de Grammont</strong>
            <br />
            Avenue Albert Einstein
            <br />
            34000, Montpellier
            <br />
            France
          </Info>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.google.com/maps/place/Avenue+Albert+Einstein,+34000+Montpellier,+France/@43.611282,3.918494,15z/data=!4m5!3m4!1s0x12b6a59d9ca3472f:0xc134e6f411c6b930!8m2!3d43.6112821!4d3.9184941?hl=fr-FR"
          >
            Get directions &rarr;
          </a>
        </AnimatedBlock>
        <AnimatedBlock style={fadeIn(750)}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4144.475543513582!2d3.926279776329348!3d43.61546154228579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b6a5a30acac847%3A0xfb0491e2a724d1a8!2sParc%20du%20Ch%C3%A2teau%20de%20Grammont!5e0!3m2!1sfr!2sfr!4v1617118979546!5m2!1sfr!2sfr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
            width="600"
            height="450"
            frameBorder="0"
            style={{
              border: 0,
              width: '100%',
              height: '350px',
            }}
  
            allowFullScreen
          />
        </AnimatedBlock>
      </Content>
      <Content narrow>
        <AnimatedBlock style={fadeInTrigger()}>
          <h3 ref={wrappedRef}>Car Parking &amp; Taxis</h3>
          <p>
            There will be a free car park for guests, you are welcome to leave
            your cars during the civil wedding and reception. 
          </p>
          <p>
             If you are planning to use public transport like bus or tram, you can easily use the Moovit application
             and trace your route on the map above before the day.
          
          </p>
        </AnimatedBlock>
      </Content>
    </Layout>
  )
}

export default Venue
